import { type DataChipSuffixType } from '@pkg/components';

export function getNumberSign(value = 0) {
    if (value === 0) return '';
    return value > 0 ? '+' : '-';
}

export function getNumberDirection(value = 0): DataChipSuffixType {
    if (value === 0) return 'neutral';
    return value > 0 ? 'positive' : 'negative';
}
